// The one-line intro at the top of every page (owner, 2026-09-28). It replaced
// the page title + subheader pair: the sidebar now names the section and the
// selected header tab names the page (`PageTabs.tsx`), so a title repeated that
// name a third time. What was left is the sentence that says what the page is
// for, standing on its own as the first line of the body.
//
// One component so every page's intro looks the same. It is not a heading, so
// it is not a Title — the page's name lives in the tab above it.
import type { ReactNode } from 'react'
import { Body1, makeStyles, mergeClasses, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  intro: {
    display: 'block',
    color: tokens.colorNeutralForeground2,
    marginBottom: '16px',
  },
})

/** `className` is for spacing only — a page laid out with a column gap drops
    the bottom margin so the two do not add up. */
export function ScreenIntro({ children, className }: { children: ReactNode; className?: string }) {
  const s = useStyles()
  return <Body1 className={mergeClasses(s.intro, className)}>{children}</Body1>
}
